interface PawapayErrorResponse {
    code: number;
    message: string;
}

export interface PaymantPawapayState {
    paymentPawapayData: any;
    loading: boolean;
    paymentPawapayErrorDara: PawapayErrorResponse | null;
}


export enum PaymantPawapayActionTypes {
    FETCH_PAWAPAY_PAYMENT_DATA = "FETCH_PAWAPAY_PAYMENT_DATA",
    FETCH_PAWAPAY_PAYMENT_DATA_SUCCESS = "FETCH_PAWAPAY_PAYMENT_DATA_SUCCESS",
    FETCH_PAWAPAY_PAYMENT_DATA_ERROR = "FETCH_PAWAPAY_PAYMENT_DATA_ERROR",
}

export type PaymantPawapayAction =
    | { type: PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA }
    | { type: PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA_SUCCESS; payload: any }
    | { type: PaymantPawapayActionTypes.FETCH_PAWAPAY_PAYMENT_DATA_ERROR; payload: any };